var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _rect2, _rect3, _rect4, _rect5, _path22, _rect6, _rect7, _rect8, _rect9, _rect10, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _circle, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _circle2, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _circle3, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _circle4, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _rect11, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _rect12, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _circle5, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _circle6, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _circle7, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _circle8, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _circle9, _path334, _path335, _path336, _path337, _path338, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSystem3000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1044,
    height: 620,
    viewBox: "0 0 1044 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.5 109V557",
    stroke: "black",
    strokeOpacity: 0.38,
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.5 109V557",
    stroke: "black",
    strokeOpacity: 0.38,
    strokeDasharray: "2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5 109V557",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 109V557",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 216H463V222H41V216Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0024 196.222C23.0024 189.222 22.0001 175.722 21.5029 173.222C21.1052 171.223 22.8032 170.222 24.0029 171.722C25.7563 173.915 27.5102 190.338 26.5661 207.161C28.7501 205.244 40.5 206.296 40.5 213.223V224.312C40.5 229.291 34.4294 231.235 30.2041 231.222L30.4993 231.223C28.9992 231.223 26.5587 231.716 26.4993 235.224C25.9993 264.723 23.6173 265.224 22.4993 265.224C21.4993 265.224 20.4993 264.223 20.9993 262.224C21.542 260.055 22.9993 243.224 22.4993 237.224C22.2953 234.776 21.303 233.395 20.1582 232.694L20.2815 232.704C19.5006 232.568 19.5002 231.684 19.5 231.223V231.463C11.3547 234.702 4.42219 230.986 2 228.261V209.223C4.66667 206.223 12.8 202.022 22 207.222L22.1424 207.5C22.6371 202.725 23.0024 198.483 23.0024 196.222Z",
    fill: "url(#paint0_linear_59_24747)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 211.121C18.3061 212.17 16 215.177 16 218.722C16 221.656 17.5792 224.221 19.9339 225.613M26.335 211.068C29.6142 212.067 32 215.116 32 218.722C32 223.141 28.4183 226.722 24 226.722C23.6613 226.722 23.3276 226.701 23 226.66",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0024 221.722C25.0024 222.556 23.603 223.222 23.0024 226.222C22.6853 227.807 22 232.722 20.5 232.722C19.5 232.722 19.5002 231.722 19.5 231.222C19.4991 229.222 23.0024 203.222 23.0024 196.222C23.0024 189.222 22.0001 175.722 21.5029 173.222C21.1052 171.223 22.8032 170.222 24.0029 171.722C26.0022 174.223 28.002 195.223 26.0024 214.222",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4993 237.224L22.2003 237.249L22.4993 237.224ZM20.9993 262.224L20.7082 262.151L20.9993 262.224ZM26.4993 235.224L26.1993 235.219L26.4993 235.224ZM30.4993 231.223V231.523C30.6399 231.523 30.7617 231.426 30.7921 231.288C30.8226 231.151 30.7536 231.011 30.6262 230.952L30.4993 231.223ZM22.2003 237.249C22.4481 240.222 22.2109 245.907 21.841 251.139C21.6564 253.751 21.4393 256.243 21.2345 258.216C21.0286 260.2 20.8376 261.634 20.7082 262.151L21.2903 262.297C21.4323 261.73 21.6269 260.247 21.8313 258.278C22.0368 256.297 22.2545 253.799 22.4395 251.182C22.809 245.956 23.0504 240.225 22.7982 237.199L22.2003 237.249ZM20.7082 262.151C20.4444 263.206 20.5653 264.045 20.9323 264.633C21.3 265.221 21.8965 265.524 22.4993 265.524V264.924C22.102 264.924 21.6985 264.727 21.4412 264.315C21.1833 263.902 21.0542 263.241 21.2903 262.297L20.7082 262.151ZM22.4993 265.524C22.6508 265.524 22.8578 265.517 23.0859 265.423C23.3162 265.328 23.5434 265.156 23.764 264.867C24.1951 264.303 24.6239 263.263 25.0247 261.348C25.8288 257.505 26.5492 249.98 26.7992 235.229L26.1993 235.219C25.9493 249.968 25.2288 257.443 24.4374 261.225C24.0404 263.122 23.6329 264.051 23.2873 264.503C23.1195 264.722 22.9733 264.82 22.8573 264.868C22.7393 264.916 22.6272 264.924 22.4993 264.924V265.524ZM26.7992 235.229C26.8276 233.553 27.4185 232.651 28.1307 232.154C28.8617 231.644 29.7733 231.523 30.4993 231.523V230.923C29.7252 230.923 28.6666 231.049 27.7874 231.662C26.8895 232.289 26.2304 233.387 26.1993 235.219L26.7992 235.229ZM30.6262 230.952C28.9464 230.167 25.6599 229.272 22.2095 229.78L22.2968 230.374C25.608 229.886 28.7756 230.75 30.3724 231.495L30.6262 230.952ZM20.0016 232.95C21.0505 233.592 22.0028 234.879 22.2003 237.249L22.7982 237.199C22.5879 234.674 21.5554 233.198 20.3148 232.438L20.0016 232.95Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 207.222C12.8 202.022 4.66667 206.223 2 209.223V228.262C4.42219 230.986 11.3547 234.702 19.5 231.463",
    stroke: "black",
    strokeWidth: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 207.223C28.5 205.222 40.5 206.223 40.5 213.223V224.312C40.5 229.298 34.4135 231.24 30.1875 231.222",
    stroke: "black",
    strokeWidth: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 213.723C40.5 213.17 40.9477 212.723 41.5 212.723V212.723C42.0523 212.723 42.5 213.17 42.5 213.723V223.723C42.5 224.275 42.0523 224.723 41.5 224.723V224.723C40.9477 224.723 40.5 224.275 40.5 223.723V213.723Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40 446H468V452H40V446Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0024 426.222C23.0024 419.222 22.0001 405.722 21.5029 403.222C21.1052 401.223 22.8032 400.222 24.0029 401.722C25.7563 403.915 27.5102 420.338 26.5661 437.161C28.7501 435.244 40.5 436.296 40.5 443.223V454.312C40.5 459.291 34.4294 461.235 30.2041 461.222L30.4993 461.223C28.9992 461.223 26.5587 461.716 26.4993 465.224C25.9993 494.723 23.6173 495.224 22.4993 495.224C21.4993 495.224 20.4993 494.223 20.9993 492.224C21.542 490.055 22.9993 473.224 22.4993 467.224C22.2953 464.776 21.303 463.395 20.1582 462.694L20.2815 462.704C19.5006 462.568 19.5002 461.684 19.5 461.223V461.463C11.3547 464.702 4.42219 460.986 2 458.261V439.223C4.66667 436.223 12.8 432.022 22 437.222L22.1424 437.5C22.6371 432.725 23.0024 428.483 23.0024 426.222Z",
    fill: "url(#paint1_linear_59_24747)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 441.121C18.3061 442.17 16 445.177 16 448.722C16 451.656 17.5792 454.221 19.9339 455.613M26.335 441.068C29.6142 442.067 32 445.116 32 448.722C32 453.141 28.4183 456.722 24 456.722C23.6613 456.722 23.3276 456.701 23 456.66",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0024 451.722C25.0024 452.556 23.603 453.222 23.0024 456.222C22.6853 457.807 22 462.722 20.5 462.722C19.5 462.722 19.5002 461.722 19.5 461.222C19.4991 459.222 23.0024 433.222 23.0024 426.222C23.0024 419.222 22.0001 405.722 21.5029 403.222C21.1052 401.223 22.8032 400.222 24.0029 401.722C26.0022 404.223 28.002 425.223 26.0024 444.222",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4993 467.224L22.2003 467.249L22.4993 467.224ZM20.9993 492.224L20.7082 492.151L20.9993 492.224ZM26.4993 465.224L26.1993 465.219L26.4993 465.224ZM30.4993 461.223V461.523C30.6399 461.523 30.7617 461.426 30.7921 461.288C30.8226 461.151 30.7536 461.011 30.6262 460.952L30.4993 461.223ZM22.2003 467.249C22.4481 470.222 22.2109 475.907 21.841 481.139C21.6564 483.751 21.4393 486.243 21.2345 488.216C21.0286 490.2 20.8376 491.634 20.7082 492.151L21.2903 492.297C21.4323 491.73 21.6269 490.247 21.8313 488.278C22.0368 486.297 22.2545 483.799 22.4395 481.182C22.809 475.956 23.0504 470.225 22.7982 467.199L22.2003 467.249ZM20.7082 492.151C20.4444 493.206 20.5653 494.045 20.9323 494.633C21.3 495.221 21.8965 495.524 22.4993 495.524V494.924C22.102 494.924 21.6985 494.727 21.4412 494.315C21.1833 493.902 21.0542 493.241 21.2903 492.297L20.7082 492.151ZM22.4993 495.524C22.6508 495.524 22.8578 495.517 23.0859 495.423C23.3162 495.328 23.5434 495.156 23.764 494.867C24.1951 494.303 24.6239 493.263 25.0247 491.348C25.8288 487.505 26.5492 479.98 26.7992 465.229L26.1993 465.219C25.9493 479.968 25.2288 487.443 24.4374 491.225C24.0404 493.122 23.6329 494.051 23.2873 494.503C23.1195 494.722 22.9733 494.82 22.8573 494.868C22.7393 494.916 22.6272 494.924 22.4993 494.924V495.524ZM26.7992 465.229C26.8276 463.553 27.4185 462.651 28.1307 462.154C28.8617 461.644 29.7733 461.523 30.4993 461.523V460.923C29.7252 460.923 28.6666 461.049 27.7874 461.662C26.8895 462.289 26.2304 463.387 26.1993 465.219L26.7992 465.229ZM30.6262 460.952C28.9464 460.167 25.6599 459.272 22.2095 459.78L22.2968 460.374C25.608 459.886 28.7756 460.75 30.3724 461.495L30.6262 460.952ZM20.0016 462.95C21.0505 463.592 22.0028 464.879 22.2003 467.249L22.7982 467.199C22.5879 464.674 21.5554 463.198 20.3148 462.438L20.0016 462.95Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22 437.222C12.8 432.022 4.66667 436.223 2 439.223V458.262C4.42219 460.986 11.3547 464.702 19.5 461.463",
    stroke: "black",
    strokeWidth: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 437.223C28.5 435.222 40.5 436.223 40.5 443.223V454.312C40.5 459.298 34.4135 461.24 30.1875 461.222",
    stroke: "black",
    strokeWidth: 0.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 443.723C40.5 443.17 40.9477 442.723 41.5 442.723V442.723C42.0523 442.723 42.5 443.17 42.5 443.723V453.723C42.5 454.275 42.0523 454.723 41.5 454.723V454.723C40.9477 454.723 40.5 454.275 40.5 453.723V443.723Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M472 191H565V197H472V191Z",
    fill: "black",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 571.284,
    y: 175.3,
    width: 63.8848,
    height: 37.4,
    fill: "url(#paint2_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 635.195,
    y: 180.482,
    width: 4.58182,
    height: 27.0364,
    fill: "url(#paint3_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 566.679,
    y: 180.482,
    width: 4.58182,
    height: 27.0364,
    fill: "url(#paint4_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 639.8,
    y: 189.118,
    width: 2.85455,
    height: 9.76364,
    fill: "url(#paint5_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 563.8,
    y: 189.118,
    width: 2.85455,
    height: 9.76364,
    fill: "url(#paint6_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M472 469H565V475H472V469Z",
    fill: "black",
    fillOpacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 571.284,
    y: 453.3,
    width: 63.8848,
    height: 37.4,
    fill: "url(#paint7_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 635.195,
    y: 458.482,
    width: 4.58182,
    height: 27.0364,
    fill: "url(#paint8_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 566.679,
    y: 458.482,
    width: 4.58182,
    height: 27.0364,
    fill: "url(#paint9_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 639.8,
    y: 467.118,
    width: 2.85455,
    height: 9.76364,
    fill: "url(#paint10_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 563.8,
    y: 467.118,
    width: 2.85455,
    height: 9.76364,
    fill: "url(#paint11_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M358 260H563V266H358V260Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M325 215H308V226L312.25 227V229.5L287.5 229L282 225.5L277 233.5L284 237.5H276H267.5V259.5H272V289H280.5C280.5 293 280.5 295.5 286 295.5H332V290H351.5V272H359V241H363V237.5C363 231.9 358.667 230.5 356.5 230.5H331V234.5H326.5L320.75 229.5V227L325 226V215Z",
    fill: "url(#paint12_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M286 273C286 272.448 286.448 272 287 272H290C290.552 272 291 272.448 291 273V278C291 278.552 290.552 279 290 279H287C286.448 279 286 278.552 286 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M294 273C294 272.448 294.448 272 295 272H298C298.552 272 299 272.448 299 273V278C299 278.552 298.552 279 298 279H295C294.448 279 294 278.552 294 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M302 273C302 272.448 302.448 272 303 272H306C306.552 272 307 272.448 307 273V278C307 278.552 306.552 279 306 279H303C302.448 279 302 278.552 302 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M310 273C310 272.448 310.448 272 311 272H314C314.552 272 315 272.448 315 273V278C315 278.552 314.552 279 314 279H311C310.448 279 310 278.552 310 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M318 273C318 272.448 318.448 272 319 272H322C322.552 272 323 272.448 323 273V278C323 278.552 322.552 279 322 279H319C318.448 279 318 278.552 318 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M286 250C286 249.448 286.448 249 287 249H290C290.552 249 291 249.448 291 250V257C291 257.552 290.552 258 290 258H287C286.448 258 286 257.552 286 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M293 250C293 249.448 293.448 249 294 249H297C297.552 249 298 249.448 298 250V257C298 257.552 297.552 258 297 258H294C293.448 258 293 257.552 293 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M300 250C300 249.448 300.448 249 301 249H304C304.552 249 305 249.448 305 250V257C305 257.552 304.552 258 304 258H301C300.448 258 300 257.552 300 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M307 250C307 249.448 307.448 249 308 249H311C311.552 249 312 249.448 312 250V257C312 257.552 311.552 258 311 258H308C307.448 258 307 257.552 307 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M314 250C314 249.448 314.448 249 315 249H318C318.552 249 319 249.448 319 250V257C319 257.552 318.552 258 318 258H315C314.448 258 314 257.552 314 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M321 250C321 249.448 321.448 249 322 249H325C325.552 249 326 249.448 326 250V257C326 257.552 325.552 258 325 258H322C321.448 258 321 257.552 321 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M289 267V261H285V267M297 267V261H293V267M305 267V261H301V267M313 267V261H309V267M321 267V261H317V267M329 270V261H325V267",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M276 237.5H283V259.5H271.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M277 259.5V264.5C277 265.333 277.6 267 280 267H282.5V272H279C276.5 272 272 270.3 272 265.5V259.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M283 245H328.5H331H346.5V237H331",
    stroke: "black",
    strokeWidth: 0.6
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M282 272H358",
    stroke: "black",
    strokeWidth: 0.6
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M282 267H285",
    stroke: "black",
    strokeWidth: 0.6
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M289 267H293",
    stroke: "black",
    strokeWidth: 0.6
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M297 267H301",
    stroke: "black",
    strokeWidth: 0.6
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M305 267H309",
    stroke: "black",
    strokeWidth: 0.6
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M313 267H317",
    stroke: "black",
    strokeWidth: 0.6
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M321 267H325",
    stroke: "black",
    strokeWidth: 0.6
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M272 282H351.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M306 282V295.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M309 282V295.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M331 234V260C331 261.657 332.343 263 334 263H359",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 277.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M355 230.5V263",
    stroke: "black",
    strokeWidth: 0.6
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M283 237.5H299V245",
    stroke: "black",
    strokeWidth: 0.6
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M299 237.5H307.25C309.321 237.5 311 239.179 311 241.25V241.25C311 243.321 309.321 245 307.25 245H299V237.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M331 260.5L328.5 272",
    stroke: "black",
    strokeWidth: 0.6
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M338 272L340 263V250.5H331",
    stroke: "black",
    strokeWidth: 0.6
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M612.5 215H595.5V226L599.75 227V229.5L575 229L569.5 225.5L564.5 233.5L571.5 237.5H563.5H555V259.5H559.5V289H568C568 293 568 295.5 573.5 295.5H619.5V290H639V272H646.5V241H650.5V237.5C650.5 231.9 646.167 230.5 644 230.5H618.5V234.5H614L608.25 229.5V227L612.5 226V215Z",
    fill: "url(#paint13_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M573.5 273C573.5 272.448 573.948 272 574.5 272H577.5C578.052 272 578.5 272.448 578.5 273V278C578.5 278.552 578.052 279 577.5 279H574.5C573.948 279 573.5 278.552 573.5 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M581.5 273C581.5 272.448 581.948 272 582.5 272H585.5C586.052 272 586.5 272.448 586.5 273V278C586.5 278.552 586.052 279 585.5 279H582.5C581.948 279 581.5 278.552 581.5 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M589.5 273C589.5 272.448 589.948 272 590.5 272H593.5C594.052 272 594.5 272.448 594.5 273V278C594.5 278.552 594.052 279 593.5 279H590.5C589.948 279 589.5 278.552 589.5 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M597.5 273C597.5 272.448 597.948 272 598.5 272H601.5C602.052 272 602.5 272.448 602.5 273V278C602.5 278.552 602.052 279 601.5 279H598.5C597.948 279 597.5 278.552 597.5 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M605.5 273C605.5 272.448 605.948 272 606.5 272H609.5C610.052 272 610.5 272.448 610.5 273V278C610.5 278.552 610.052 279 609.5 279H606.5C605.948 279 605.5 278.552 605.5 278V273Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M573.5 250C573.5 249.448 573.948 249 574.5 249H577.5C578.052 249 578.5 249.448 578.5 250V257C578.5 257.552 578.052 258 577.5 258H574.5C573.948 258 573.5 257.552 573.5 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 250C580.5 249.448 580.948 249 581.5 249H584.5C585.052 249 585.5 249.448 585.5 250V257C585.5 257.552 585.052 258 584.5 258H581.5C580.948 258 580.5 257.552 580.5 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M587.5 250C587.5 249.448 587.948 249 588.5 249H591.5C592.052 249 592.5 249.448 592.5 250V257C592.5 257.552 592.052 258 591.5 258H588.5C587.948 258 587.5 257.552 587.5 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M594.5 250C594.5 249.448 594.948 249 595.5 249H598.5C599.052 249 599.5 249.448 599.5 250V257C599.5 257.552 599.052 258 598.5 258H595.5C594.948 258 594.5 257.552 594.5 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M601.5 250C601.5 249.448 601.948 249 602.5 249H605.5C606.052 249 606.5 249.448 606.5 250V257C606.5 257.552 606.052 258 605.5 258H602.5C601.948 258 601.5 257.552 601.5 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M608.5 250C608.5 249.448 608.948 249 609.5 249H612.5C613.052 249 613.5 249.448 613.5 250V257C613.5 257.552 613.052 258 612.5 258H609.5C608.948 258 608.5 257.552 608.5 257V250Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5 267V261H572.5V267M584.5 267V261H580.5V267M592.5 267V261H588.5V267M600.5 267V261H596.5V267M608.5 267V261H604.5V267M616.5 270V261H612.5V267",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M563.5 237.5H570.5V259.5H559",
    stroke: "black",
    strokeWidth: 0.6
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M564.5 259.5V264.5C564.5 265.333 565.1 267 567.5 267H570V272H566.5C564 272 559.5 270.3 559.5 265.5V259.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M570.5 245H616H618.5H634V237H618.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 272H645.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 267H572.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5 267H580.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M584.5 267H588.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M592.5 267H596.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M600.5 267H604.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M608.5 267H612.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5 282H639",
    stroke: "black",
    strokeWidth: 0.6
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M593.5 282V295.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M596.5 282V295.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M618.5 234V260C618.5 261.657 619.843 263 621.5 263H646.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.5,
    cy: 277.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M642.5 230.5V263",
    stroke: "black",
    strokeWidth: 0.6
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M570.5 237.5H586.5V245",
    stroke: "black",
    strokeWidth: 0.6
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M586.5 237.5H594.75C596.821 237.5 598.5 239.179 598.5 241.25V241.25C598.5 243.321 596.821 245 594.75 245H586.5V237.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M618.5 260.5L616 272",
    stroke: "black",
    strokeWidth: 0.6
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M625.5 272L627.5 263V250.5H618.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M358 400H571V406H358V400Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M325 356H308V367L312.25 368V370.5L287.5 370L282 366.5L277 374.5L284 378.5H276H267.5V400.5H272V430H280.5C280.5 434 280.5 436.5 286 436.5H332V431H351.5V413H359V382H363V378.5C363 372.9 358.667 371.5 356.5 371.5H331V375.5H326.5L320.75 370.5V368L325 367V356Z",
    fill: "url(#paint14_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M286 414C286 413.448 286.448 413 287 413H290C290.552 413 291 413.448 291 414V419C291 419.552 290.552 420 290 420H287C286.448 420 286 419.552 286 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M294 414C294 413.448 294.448 413 295 413H298C298.552 413 299 413.448 299 414V419C299 419.552 298.552 420 298 420H295C294.448 420 294 419.552 294 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M302 414C302 413.448 302.448 413 303 413H306C306.552 413 307 413.448 307 414V419C307 419.552 306.552 420 306 420H303C302.448 420 302 419.552 302 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M310 414C310 413.448 310.448 413 311 413H314C314.552 413 315 413.448 315 414V419C315 419.552 314.552 420 314 420H311C310.448 420 310 419.552 310 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M318 414C318 413.448 318.448 413 319 413H322C322.552 413 323 413.448 323 414V419C323 419.552 322.552 420 322 420H319C318.448 420 318 419.552 318 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M286 391C286 390.448 286.448 390 287 390H290C290.552 390 291 390.448 291 391V398C291 398.552 290.552 399 290 399H287C286.448 399 286 398.552 286 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M293 391C293 390.448 293.448 390 294 390H297C297.552 390 298 390.448 298 391V398C298 398.552 297.552 399 297 399H294C293.448 399 293 398.552 293 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M300 391C300 390.448 300.448 390 301 390H304C304.552 390 305 390.448 305 391V398C305 398.552 304.552 399 304 399H301C300.448 399 300 398.552 300 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M307 391C307 390.448 307.448 390 308 390H311C311.552 390 312 390.448 312 391V398C312 398.552 311.552 399 311 399H308C307.448 399 307 398.552 307 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M314 391C314 390.448 314.448 390 315 390H318C318.552 390 319 390.448 319 391V398C319 398.552 318.552 399 318 399H315C314.448 399 314 398.552 314 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M321 391C321 390.448 321.448 390 322 390H325C325.552 390 326 390.448 326 391V398C326 398.552 325.552 399 325 399H322C321.448 399 321 398.552 321 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M289 408V402H285V408M297 408V402H293V408M305 408V402H301V408M313 408V402H309V408M321 408V402H317V408M329 411V402H325V408",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M276 378.5H283V400.5H271.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M277 400.5V405.5C277 406.333 277.6 408 280 408H282.5V413H279C276.5 413 272 411.3 272 406.5V400.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M283 386H328.5H331H346.5V378H331",
    stroke: "black",
    strokeWidth: 0.6
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M282 413H358",
    stroke: "black",
    strokeWidth: 0.6
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M282 408H285",
    stroke: "black",
    strokeWidth: 0.6
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M289 408H293",
    stroke: "black",
    strokeWidth: 0.6
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M297 408H301",
    stroke: "black",
    strokeWidth: 0.6
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M305 408H309",
    stroke: "black",
    strokeWidth: 0.6
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M313 408H317",
    stroke: "black",
    strokeWidth: 0.6
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M321 408H325",
    stroke: "black",
    strokeWidth: 0.6
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M272 423H351.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M306 423V436.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M309 423V436.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M331 375V401C331 402.657 332.343 404 334 404H359",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 418.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M355 371.5V404",
    stroke: "black",
    strokeWidth: 0.6
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M283 378.5H299V386",
    stroke: "black",
    strokeWidth: 0.6
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M299 378.5H307.25C309.321 378.5 311 380.179 311 382.25V382.25C311 384.321 309.321 386 307.25 386H299V378.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M331 401.5L328.5 413",
    stroke: "black",
    strokeWidth: 0.6
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M338 413L340 404V391.5H331",
    stroke: "black",
    strokeWidth: 0.6
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M612.5 356H595.5V367L599.75 368V370.5L575 370L569.5 366.5L564.5 374.5L571.5 378.5H563.5H555V400.5H559.5V430H568C568 434 568 436.5 573.5 436.5H619.5V431H639V413H646.5V382H650.5V378.5C650.5 372.9 646.167 371.5 644 371.5H618.5V375.5H614L608.25 370.5V368L612.5 367V356Z",
    fill: "url(#paint15_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M573.5 414C573.5 413.448 573.948 413 574.5 413H577.5C578.052 413 578.5 413.448 578.5 414V419C578.5 419.552 578.052 420 577.5 420H574.5C573.948 420 573.5 419.552 573.5 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M581.5 414C581.5 413.448 581.948 413 582.5 413H585.5C586.052 413 586.5 413.448 586.5 414V419C586.5 419.552 586.052 420 585.5 420H582.5C581.948 420 581.5 419.552 581.5 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M589.5 414C589.5 413.448 589.948 413 590.5 413H593.5C594.052 413 594.5 413.448 594.5 414V419C594.5 419.552 594.052 420 593.5 420H590.5C589.948 420 589.5 419.552 589.5 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M597.5 414C597.5 413.448 597.948 413 598.5 413H601.5C602.052 413 602.5 413.448 602.5 414V419C602.5 419.552 602.052 420 601.5 420H598.5C597.948 420 597.5 419.552 597.5 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M605.5 414C605.5 413.448 605.948 413 606.5 413H609.5C610.052 413 610.5 413.448 610.5 414V419C610.5 419.552 610.052 420 609.5 420H606.5C605.948 420 605.5 419.552 605.5 419V414Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M573.5 391C573.5 390.448 573.948 390 574.5 390H577.5C578.052 390 578.5 390.448 578.5 391V398C578.5 398.552 578.052 399 577.5 399H574.5C573.948 399 573.5 398.552 573.5 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 391C580.5 390.448 580.948 390 581.5 390H584.5C585.052 390 585.5 390.448 585.5 391V398C585.5 398.552 585.052 399 584.5 399H581.5C580.948 399 580.5 398.552 580.5 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M587.5 391C587.5 390.448 587.948 390 588.5 390H591.5C592.052 390 592.5 390.448 592.5 391V398C592.5 398.552 592.052 399 591.5 399H588.5C587.948 399 587.5 398.552 587.5 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M594.5 391C594.5 390.448 594.948 390 595.5 390H598.5C599.052 390 599.5 390.448 599.5 391V398C599.5 398.552 599.052 399 598.5 399H595.5C594.948 399 594.5 398.552 594.5 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M601.5 391C601.5 390.448 601.948 390 602.5 390H605.5C606.052 390 606.5 390.448 606.5 391V398C606.5 398.552 606.052 399 605.5 399H602.5C601.948 399 601.5 398.552 601.5 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M608.5 391C608.5 390.448 608.948 390 609.5 390H612.5C613.052 390 613.5 390.448 613.5 391V398C613.5 398.552 613.052 399 612.5 399H609.5C608.948 399 608.5 398.552 608.5 398V391Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5 408V402H572.5V408M584.5 408V402H580.5V408M592.5 408V402H588.5V408M600.5 408V402H596.5V408M608.5 408V402H604.5V408M616.5 411V402H612.5V408",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M563.5 378.5H570.5V400.5H559",
    stroke: "black",
    strokeWidth: 0.6
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M564.5 400.5V405.5C564.5 406.333 565.1 408 567.5 408H570V413H566.5C564 413 559.5 411.3 559.5 406.5V400.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M570.5 386H616H618.5H634V378H618.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 413H645.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 408H572.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5 408H580.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M584.5 408H588.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M592.5 408H596.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M600.5 408H604.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M608.5 408H612.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5 423H639",
    stroke: "black",
    strokeWidth: 0.6
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M593.5 423V436.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M596.5 423V436.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M618.5 375V401C618.5 402.657 619.843 404 621.5 404H646.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.5,
    cy: 418.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M642.5 371.5V404",
    stroke: "black",
    strokeWidth: 0.6
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M570.5 378.5H586.5V386",
    stroke: "black",
    strokeWidth: 0.6
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M586.5 378.5H594.75C596.821 378.5 598.5 380.179 598.5 382.25V382.25C598.5 384.321 596.821 386 594.75 386H586.5V378.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M618.5 401.5L616 413",
    stroke: "black",
    strokeWidth: 0.6
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M625.5 413L627.5 404V391.5H618.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M474.616 262H462.513V291.463H474.616V262Z",
    fill: "url(#paint16_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M462.515 264.423L474.617 262.91M462.515 267.147L474.617 265.635M462.515 269.868L474.617 268.355M462.515 272.594L474.617 271.081M462.515 275.317L474.617 273.804M462.515 278.039L474.617 276.526M462.515 280.761L474.617 279.249M462.515 283.484L474.617 281.971M462.515 286.21L474.617 284.697M462.515 288.931L474.617 287.418M462.515 291.655L474.617 290.142",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M488.618 248H476.515V277.463H488.618V248Z",
    fill: "url(#paint17_linear_59_24747)",
    stroke: "#696969",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M476.517 250.423L488.619 248.91M476.517 253.147L488.619 251.635M476.517 255.868L488.619 254.355M476.517 258.594L488.619 257.081M476.517 261.317L488.619 259.804M476.517 264.039L488.619 262.526M476.517 266.761L488.619 265.249M476.517 269.484L488.619 267.971M476.517 272.21L488.619 270.697M476.517 274.931L488.619 273.418M476.517 277.655L488.619 276.142",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M488.618 180H476.515V209.463H488.618V180Z",
    fill: "url(#paint18_linear_59_24747)",
    stroke: "#696969",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M476.517 182.423L488.619 180.91M476.517 185.147L488.619 183.635M476.517 187.868L488.619 186.355M476.517 190.594L488.619 189.081M476.517 193.317L488.619 191.804M476.517 196.039L488.619 194.526M476.517 198.761L488.619 197.249M476.517 201.484L488.619 199.971M476.517 204.21L488.619 202.697M476.517 206.931L488.619 205.418M476.517 209.655L488.619 208.142",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 462.5,
    y: 176,
    width: 12.1028,
    height: 86.5352,
    fill: "url(#paint19_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M462.5 177.814L474.603 176.301M462.5 180.538L474.603 179.025M462.5 183.258L474.603 181.746M462.5 185.985L474.603 184.472M462.5 188.707L474.603 187.194M462.5 191.43L474.603 189.917M462.5 194.152L474.603 192.639M462.5 196.875L474.603 195.362M462.5 199.601L474.603 198.088M462.5 202.321L474.603 200.808M462.5 205.046L474.603 203.533M462.5 207.768L474.603 206.255M462.5 210.491L474.603 208.978M462.5 213.213L474.603 211.7M462.5 215.937L474.603 214.424M462.5 218.662L474.603 217.149M462.5 221.386L474.603 219.873M462.5 224.105L474.603 222.592M462.5 226.829L474.603 225.316M462.5 229.553L474.603 228.041M462.5 232.276L474.603 230.763M462.5 235L474.603 233.487M462.5 237.721L474.603 236.208M462.5 240.445L474.603 238.932M462.5 243.169L474.603 241.657M462.5 245.892L474.603 244.379M462.5 248.616L474.603 247.103M462.5 251.339L474.603 249.826M462.5 254.059L474.603 252.546M462.5 256.783L474.603 255.271M462.5 259.51L474.603 257.997M462.5 262.23L474.603 260.717",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M460.618 248H448.515V277.463H460.618V248Z",
    fill: "url(#paint20_linear_59_24747)",
    stroke: "#696969",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M448.517 250.423L460.619 248.91M448.517 253.147L460.619 251.635M448.517 255.868L460.619 254.355M448.517 258.594L460.619 257.081M448.517 261.317L460.619 259.804M448.517 264.039L460.619 262.526M448.517 266.761L460.619 265.249M448.517 269.484L460.619 267.971M448.517 272.21L460.619 270.697M448.517 274.931L460.619 273.418M448.517 277.655L460.619 276.142",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M474.616 404.655H462.513V375.193H474.616V404.655Z",
    fill: "url(#paint21_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M462.515 402.232L474.617 403.745M462.515 399.508L474.617 401.021M462.515 396.787L474.617 398.3M462.515 394.061L474.617 395.574M462.515 391.339L474.617 392.852M462.515 388.616L474.617 390.129M462.515 385.894L474.617 387.407M462.515 383.171L474.617 384.684M462.515 380.445L474.617 381.958M462.515 377.725L474.617 379.237M462.515 375L474.617 376.513",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M488.618 418.655H476.515V389.193H488.618V418.655Z",
    fill: "url(#paint22_linear_59_24747)",
    stroke: "#696969",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M476.517 416.232L488.619 417.745M476.517 413.508L488.619 415.021M476.517 410.787L488.619 412.3M476.517 408.061L488.619 409.574M476.517 405.339L488.619 406.852M476.517 402.616L488.619 404.129M476.517 399.894L488.619 401.407M476.517 397.171L488.619 398.684M476.517 394.445L488.619 395.958M476.517 391.725L488.619 393.237M476.517 389L488.619 390.513",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M488.618 486.655H476.515V457.193H488.618V486.655Z",
    fill: "url(#paint23_linear_59_24747)",
    stroke: "#696969",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M476.517 484.232L488.619 485.745M476.517 481.508L488.619 483.021M476.517 478.787L488.619 480.3M476.517 476.061L488.619 477.574M476.517 473.339L488.619 474.852M476.517 470.616L488.619 472.129M476.517 467.894L488.619 469.407M476.517 465.171L488.619 466.684M476.517 462.445L488.619 463.958M476.517 459.725L488.619 461.237M476.517 457L488.619 458.513",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 12.1028,
    height: 86.5352,
    transform: "matrix(1 0 0 -1 462.5 490.655)",
    fill: "url(#paint24_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M462.5 488.842L474.603 490.354M462.5 486.117L474.603 487.63M462.5 483.397L474.603 484.91M462.5 480.67L474.603 482.183M462.5 477.948L474.603 479.461M462.5 475.226L474.603 476.738M462.5 472.503L474.603 474.016M462.5 469.781L474.603 471.294M462.5 467.054L474.603 468.567M462.5 464.334L474.603 465.847M462.5 461.61L474.603 463.122M462.5 458.887L474.603 460.4M462.5 456.165L474.603 457.678M462.5 453.442L474.603 454.955M462.5 450.718L474.603 452.231M462.5 447.994L474.603 449.506M462.5 445.269L474.603 446.782M462.5 442.551L474.603 444.064M462.5 439.826L474.603 441.339M462.5 437.102L474.603 438.615M462.5 434.379L474.603 435.892M462.5 431.655L474.603 433.168M462.5 428.935L474.603 430.447M462.5 426.21L474.603 427.723M462.5 423.486L474.603 424.999M462.5 420.763L474.603 422.276M462.5 418.039L474.603 419.552M462.5 415.317L474.603 416.829M462.5 412.596L474.603 414.109M462.5 409.872L474.603 411.385M462.5 407.145L474.603 408.658M462.5 404.425L474.603 405.938",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M460.618 418.655H448.515V389.193H460.618V418.655Z",
    fill: "url(#paint25_linear_59_24747)",
    stroke: "#696969",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M448.517 416.232L460.619 417.745M448.517 413.508L460.619 415.021M448.517 410.787L460.619 412.3M448.517 408.061L460.619 409.574M448.517 405.339L460.619 406.852M448.517 402.616L460.619 404.129M448.517 399.894L460.619 401.407M448.517 397.171L460.619 398.684M448.517 394.445L460.619 395.958M448.517 391.725L460.619 393.237M448.517 389L460.619 390.513",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M960.5 620L960.5 45L966.5 45L966.5 620L960.5 620Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.25 198.507L1044 180.754L1016.25 163V178.254H966V184.254H1016.25V198.507Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.25 350.507L1044 332.754L1016.25 315V330.254H966V336.254H1016.25V350.507Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.25 503.507L1044 485.754L1016.25 468V483.254H966V489.254H1016.25V503.507Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M867.5 375H850.5V386L854.75 387V389.5L830 389L824.5 385.5L819.5 393.5L826.5 397.5H818.5H810V419.5H814.5V449H823C823 453 823 455.5 828.5 455.5H874.5V450H894V432H901.5V401H905.5V397.5C905.5 391.9 901.167 390.5 899 390.5H873.5V394.5H869L863.25 389.5V387L867.5 386V375Z",
    fill: "url(#paint26_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 433C828.5 432.448 828.948 432 829.5 432H832.5C833.052 432 833.5 432.448 833.5 433V438C833.5 438.552 833.052 439 832.5 439H829.5C828.948 439 828.5 438.552 828.5 438V433Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M836.5 433C836.5 432.448 836.948 432 837.5 432H840.5C841.052 432 841.5 432.448 841.5 433V438C841.5 438.552 841.052 439 840.5 439H837.5C836.948 439 836.5 438.552 836.5 438V433Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 433C844.5 432.448 844.948 432 845.5 432H848.5C849.052 432 849.5 432.448 849.5 433V438C849.5 438.552 849.052 439 848.5 439H845.5C844.948 439 844.5 438.552 844.5 438V433Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M852.5 433C852.5 432.448 852.948 432 853.5 432H856.5C857.052 432 857.5 432.448 857.5 433V438C857.5 438.552 857.052 439 856.5 439H853.5C852.948 439 852.5 438.552 852.5 438V433Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M860.5 433C860.5 432.448 860.948 432 861.5 432H864.5C865.052 432 865.5 432.448 865.5 433V438C865.5 438.552 865.052 439 864.5 439H861.5C860.948 439 860.5 438.552 860.5 438V433Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 410C828.5 409.448 828.948 409 829.5 409H832.5C833.052 409 833.5 409.448 833.5 410V417C833.5 417.552 833.052 418 832.5 418H829.5C828.948 418 828.5 417.552 828.5 417V410Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M835.5 410C835.5 409.448 835.948 409 836.5 409H839.5C840.052 409 840.5 409.448 840.5 410V417C840.5 417.552 840.052 418 839.5 418H836.5C835.948 418 835.5 417.552 835.5 417V410Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M842.5 410C842.5 409.448 842.948 409 843.5 409H846.5C847.052 409 847.5 409.448 847.5 410V417C847.5 417.552 847.052 418 846.5 418H843.5C842.948 418 842.5 417.552 842.5 417V410Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M849.5 410C849.5 409.448 849.948 409 850.5 409H853.5C854.052 409 854.5 409.448 854.5 410V417C854.5 417.552 854.052 418 853.5 418H850.5C849.948 418 849.5 417.552 849.5 417V410Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M856.5 410C856.5 409.448 856.948 409 857.5 409H860.5C861.052 409 861.5 409.448 861.5 410V417C861.5 417.552 861.052 418 860.5 418H857.5C856.948 418 856.5 417.552 856.5 417V410Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 410C863.5 409.448 863.948 409 864.5 409H867.5C868.052 409 868.5 409.448 868.5 410V417C868.5 417.552 868.052 418 867.5 418H864.5C863.948 418 863.5 417.552 863.5 417V410Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 427V421H827.5V427M839.5 427V421H835.5V427M847.5 427V421H843.5V427M855.5 427V421H851.5V427M863.5 427V421H859.5V427M871.5 430V421H867.5V427",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M818.5 397.5H825.5V419.5H814",
    stroke: "black",
    strokeWidth: 0.6
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5 419.5V424.5C819.5 425.333 820.1 427 822.5 427H825V432H821.5C819 432 814.5 430.3 814.5 425.5V419.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 405H871H873.5H889V397H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 432H900.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 427H827.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 427H835.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M839.5 427H843.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M847.5 427H851.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M855.5 427H859.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 427H867.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M814.5 442H894",
    stroke: "black",
    strokeWidth: 0.6
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M848.5 442V455.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M851.5 442V455.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 394V420C873.5 421.657 874.843 423 876.5 423H901.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.5,
    cy: 437.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M897.5 390.5V423",
    stroke: "black",
    strokeWidth: 0.6
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 397.5H841.5V405",
    stroke: "black",
    strokeWidth: 0.6
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M841.5 397.5H849.75C851.821 397.5 853.5 399.179 853.5 401.25V401.25C853.5 403.321 851.821 405 849.75 405H841.5V397.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 420.5L871 432",
    stroke: "black",
    strokeWidth: 0.6
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M880.5 432L882.5 423V410.5H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M901 102H961V108H901V102Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M867.5 65H850.5V76L854.75 77V79.5L830 79L824.5 75.5L819.5 83.5L826.5 87.5H818.5H810V109.5H814.5V139H823C823 143 823 145.5 828.5 145.5H874.5V140H894V122H901.5V91H905.5V87.5C905.5 81.9 901.167 80.5 899 80.5H873.5V84.5H869L863.25 79.5V77L867.5 76V65Z",
    fill: "url(#paint27_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 123C828.5 122.448 828.948 122 829.5 122H832.5C833.052 122 833.5 122.448 833.5 123V128C833.5 128.552 833.052 129 832.5 129H829.5C828.948 129 828.5 128.552 828.5 128V123Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M836.5 123C836.5 122.448 836.948 122 837.5 122H840.5C841.052 122 841.5 122.448 841.5 123V128C841.5 128.552 841.052 129 840.5 129H837.5C836.948 129 836.5 128.552 836.5 128V123Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 123C844.5 122.448 844.948 122 845.5 122H848.5C849.052 122 849.5 122.448 849.5 123V128C849.5 128.552 849.052 129 848.5 129H845.5C844.948 129 844.5 128.552 844.5 128V123Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M852.5 123C852.5 122.448 852.948 122 853.5 122H856.5C857.052 122 857.5 122.448 857.5 123V128C857.5 128.552 857.052 129 856.5 129H853.5C852.948 129 852.5 128.552 852.5 128V123Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M860.5 123C860.5 122.448 860.948 122 861.5 122H864.5C865.052 122 865.5 122.448 865.5 123V128C865.5 128.552 865.052 129 864.5 129H861.5C860.948 129 860.5 128.552 860.5 128V123Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 100C828.5 99.4477 828.948 99 829.5 99H832.5C833.052 99 833.5 99.4477 833.5 100V107C833.5 107.552 833.052 108 832.5 108H829.5C828.948 108 828.5 107.552 828.5 107V100Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M835.5 100C835.5 99.4477 835.948 99 836.5 99H839.5C840.052 99 840.5 99.4477 840.5 100V107C840.5 107.552 840.052 108 839.5 108H836.5C835.948 108 835.5 107.552 835.5 107V100Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M842.5 100C842.5 99.4477 842.948 99 843.5 99H846.5C847.052 99 847.5 99.4477 847.5 100V107C847.5 107.552 847.052 108 846.5 108H843.5C842.948 108 842.5 107.552 842.5 107V100Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M849.5 100C849.5 99.4477 849.948 99 850.5 99H853.5C854.052 99 854.5 99.4477 854.5 100V107C854.5 107.552 854.052 108 853.5 108H850.5C849.948 108 849.5 107.552 849.5 107V100Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M856.5 100C856.5 99.4477 856.948 99 857.5 99H860.5C861.052 99 861.5 99.4477 861.5 100V107C861.5 107.552 861.052 108 860.5 108H857.5C856.948 108 856.5 107.552 856.5 107V100Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 100C863.5 99.4477 863.948 99 864.5 99H867.5C868.052 99 868.5 99.4477 868.5 100V107C868.5 107.552 868.052 108 867.5 108H864.5C863.948 108 863.5 107.552 863.5 107V100Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 117V111H827.5V117M839.5 117V111H835.5V117M847.5 117V111H843.5V117M855.5 117V111H851.5V117M863.5 117V111H859.5V117M871.5 120V111H867.5V117",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M818.5 87.5H825.5V109.5H814",
    stroke: "black",
    strokeWidth: 0.6
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5 109.5V114.5C819.5 115.333 820.1 117 822.5 117H825V122H821.5C819 122 814.5 120.3 814.5 115.5V109.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 95H871H873.5H889V87H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 122H900.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 117H827.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 117H835.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M839.5 117H843.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M847.5 117H851.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M855.5 117H859.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 117H867.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M814.5 132H894",
    stroke: "black",
    strokeWidth: 0.6
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M848.5 132V145.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M851.5 132V145.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 84V110C873.5 111.657 874.843 113 876.5 113H901.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.5,
    cy: 127.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M897.5 80.5V113",
    stroke: "black",
    strokeWidth: 0.6
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 87.5H841.5V95",
    stroke: "black",
    strokeWidth: 0.6
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M841.5 87.5H849.75C851.821 87.5 853.5 89.1789 853.5 91.25V91.25C853.5 93.3211 851.821 95 849.75 95H841.5V87.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 110.5L871 122",
    stroke: "black",
    strokeWidth: 0.6
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M880.5 122L882.5 113V100.5H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M901 254H961V260H901V254Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M867.5 217H850.5V228L854.75 229V231.5L830 231L824.5 227.5L819.5 235.5L826.5 239.5H818.5H810V261.5H814.5V291H823C823 295 823 297.5 828.5 297.5H874.5V292H894V274H901.5V243H905.5V239.5C905.5 233.9 901.167 232.5 899 232.5H873.5V236.5H869L863.25 231.5V229L867.5 228V217Z",
    fill: "url(#paint28_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 275C828.5 274.448 828.948 274 829.5 274H832.5C833.052 274 833.5 274.448 833.5 275V280C833.5 280.552 833.052 281 832.5 281H829.5C828.948 281 828.5 280.552 828.5 280V275Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M836.5 275C836.5 274.448 836.948 274 837.5 274H840.5C841.052 274 841.5 274.448 841.5 275V280C841.5 280.552 841.052 281 840.5 281H837.5C836.948 281 836.5 280.552 836.5 280V275Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 275C844.5 274.448 844.948 274 845.5 274H848.5C849.052 274 849.5 274.448 849.5 275V280C849.5 280.552 849.052 281 848.5 281H845.5C844.948 281 844.5 280.552 844.5 280V275Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M852.5 275C852.5 274.448 852.948 274 853.5 274H856.5C857.052 274 857.5 274.448 857.5 275V280C857.5 280.552 857.052 281 856.5 281H853.5C852.948 281 852.5 280.552 852.5 280V275Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M860.5 275C860.5 274.448 860.948 274 861.5 274H864.5C865.052 274 865.5 274.448 865.5 275V280C865.5 280.552 865.052 281 864.5 281H861.5C860.948 281 860.5 280.552 860.5 280V275Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 252C828.5 251.448 828.948 251 829.5 251H832.5C833.052 251 833.5 251.448 833.5 252V259C833.5 259.552 833.052 260 832.5 260H829.5C828.948 260 828.5 259.552 828.5 259V252Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M835.5 252C835.5 251.448 835.948 251 836.5 251H839.5C840.052 251 840.5 251.448 840.5 252V259C840.5 259.552 840.052 260 839.5 260H836.5C835.948 260 835.5 259.552 835.5 259V252Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M842.5 252C842.5 251.448 842.948 251 843.5 251H846.5C847.052 251 847.5 251.448 847.5 252V259C847.5 259.552 847.052 260 846.5 260H843.5C842.948 260 842.5 259.552 842.5 259V252Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M849.5 252C849.5 251.448 849.948 251 850.5 251H853.5C854.052 251 854.5 251.448 854.5 252V259C854.5 259.552 854.052 260 853.5 260H850.5C849.948 260 849.5 259.552 849.5 259V252Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M856.5 252C856.5 251.448 856.948 251 857.5 251H860.5C861.052 251 861.5 251.448 861.5 252V259C861.5 259.552 861.052 260 860.5 260H857.5C856.948 260 856.5 259.552 856.5 259V252Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 252C863.5 251.448 863.948 251 864.5 251H867.5C868.052 251 868.5 251.448 868.5 252V259C868.5 259.552 868.052 260 867.5 260H864.5C863.948 260 863.5 259.552 863.5 259V252Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 269V263H827.5V269M839.5 269V263H835.5V269M847.5 269V263H843.5V269M855.5 269V263H851.5V269M863.5 269V263H859.5V269M871.5 272V263H867.5V269",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M818.5 239.5H825.5V261.5H814",
    stroke: "black",
    strokeWidth: 0.6
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5 261.5V266.5C819.5 267.333 820.1 269 822.5 269H825V274H821.5C819 274 814.5 272.3 814.5 267.5V261.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 247H871H873.5H889V239H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 274H900.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 269H827.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 269H835.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M839.5 269H843.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M847.5 269H851.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M855.5 269H859.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 269H867.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M814.5 284H894",
    stroke: "black",
    strokeWidth: 0.6
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M848.5 284V297.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M851.5 284V297.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 236V262C873.5 263.657 874.843 265 876.5 265H901.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.5,
    cy: 279.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M897.5 232.5V265",
    stroke: "black",
    strokeWidth: 0.6
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 239.5H841.5V247",
    stroke: "black",
    strokeWidth: 0.6
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M841.5 239.5H849.75C851.821 239.5 853.5 241.179 853.5 243.25V243.25C853.5 245.321 851.821 247 849.75 247H841.5V239.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 262.5L871 274",
    stroke: "black",
    strokeWidth: 0.6
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M880.5 274L882.5 265V252.5H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M901 406H961V412H901V406Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M867.5 369H850.5V380L854.75 381V383.5L830 383L824.5 379.5L819.5 387.5L826.5 391.5H818.5H810V413.5H814.5V443H823C823 447 823 449.5 828.5 449.5H874.5V444H894V426H901.5V395H905.5V391.5C905.5 385.9 901.167 384.5 899 384.5H873.5V388.5H869L863.25 383.5V381L867.5 380V369Z",
    fill: "url(#paint29_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 427C828.5 426.448 828.948 426 829.5 426H832.5C833.052 426 833.5 426.448 833.5 427V432C833.5 432.552 833.052 433 832.5 433H829.5C828.948 433 828.5 432.552 828.5 432V427Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M836.5 427C836.5 426.448 836.948 426 837.5 426H840.5C841.052 426 841.5 426.448 841.5 427V432C841.5 432.552 841.052 433 840.5 433H837.5C836.948 433 836.5 432.552 836.5 432V427Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 427C844.5 426.448 844.948 426 845.5 426H848.5C849.052 426 849.5 426.448 849.5 427V432C849.5 432.552 849.052 433 848.5 433H845.5C844.948 433 844.5 432.552 844.5 432V427Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M852.5 427C852.5 426.448 852.948 426 853.5 426H856.5C857.052 426 857.5 426.448 857.5 427V432C857.5 432.552 857.052 433 856.5 433H853.5C852.948 433 852.5 432.552 852.5 432V427Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M860.5 427C860.5 426.448 860.948 426 861.5 426H864.5C865.052 426 865.5 426.448 865.5 427V432C865.5 432.552 865.052 433 864.5 433H861.5C860.948 433 860.5 432.552 860.5 432V427Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 404C828.5 403.448 828.948 403 829.5 403H832.5C833.052 403 833.5 403.448 833.5 404V411C833.5 411.552 833.052 412 832.5 412H829.5C828.948 412 828.5 411.552 828.5 411V404Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M835.5 404C835.5 403.448 835.948 403 836.5 403H839.5C840.052 403 840.5 403.448 840.5 404V411C840.5 411.552 840.052 412 839.5 412H836.5C835.948 412 835.5 411.552 835.5 411V404Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M842.5 404C842.5 403.448 842.948 403 843.5 403H846.5C847.052 403 847.5 403.448 847.5 404V411C847.5 411.552 847.052 412 846.5 412H843.5C842.948 412 842.5 411.552 842.5 411V404Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M849.5 404C849.5 403.448 849.948 403 850.5 403H853.5C854.052 403 854.5 403.448 854.5 404V411C854.5 411.552 854.052 412 853.5 412H850.5C849.948 412 849.5 411.552 849.5 411V404Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M856.5 404C856.5 403.448 856.948 403 857.5 403H860.5C861.052 403 861.5 403.448 861.5 404V411C861.5 411.552 861.052 412 860.5 412H857.5C856.948 412 856.5 411.552 856.5 411V404Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 404C863.5 403.448 863.948 403 864.5 403H867.5C868.052 403 868.5 403.448 868.5 404V411C868.5 411.552 868.052 412 867.5 412H864.5C863.948 412 863.5 411.552 863.5 411V404Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 421V415H827.5V421M839.5 421V415H835.5V421M847.5 421V415H843.5V421M855.5 421V415H851.5V421M863.5 421V415H859.5V421M871.5 424V415H867.5V421",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M818.5 391.5H825.5V413.5H814",
    stroke: "black",
    strokeWidth: 0.6
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5 413.5V418.5C819.5 419.333 820.1 421 822.5 421H825V426H821.5C819 426 814.5 424.3 814.5 419.5V413.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 399H871H873.5H889V391H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 426H900.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 421H827.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 421H835.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M839.5 421H843.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M847.5 421H851.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M855.5 421H859.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 421H867.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M814.5 436H894",
    stroke: "black",
    strokeWidth: 0.6
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M848.5 436V449.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M851.5 436V449.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 388V414C873.5 415.657 874.843 417 876.5 417H901.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.5,
    cy: 431.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M897.5 384.5V417",
    stroke: "black",
    strokeWidth: 0.6
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 391.5H841.5V399",
    stroke: "black",
    strokeWidth: 0.6
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M841.5 391.5H849.75C851.821 391.5 853.5 393.179 853.5 395.25V395.25C853.5 397.321 851.821 399 849.75 399H841.5V391.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 414.5L871 426",
    stroke: "black",
    strokeWidth: 0.6
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M880.5 426L882.5 417V404.5H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M901 559H961V565H901V559Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M867.5 521H850.5V532L854.75 533V535.5L830 535L824.5 531.5L819.5 539.5L826.5 543.5H818.5H810V565.5H814.5V595H823C823 599 823 601.5 828.5 601.5H874.5V596H894V578H901.5V547H905.5V543.5C905.5 537.9 901.167 536.5 899 536.5H873.5V540.5H869L863.25 535.5V533L867.5 532V521Z",
    fill: "url(#paint30_linear_59_24747)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 579C828.5 578.448 828.948 578 829.5 578H832.5C833.052 578 833.5 578.448 833.5 579V584C833.5 584.552 833.052 585 832.5 585H829.5C828.948 585 828.5 584.552 828.5 584V579Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M836.5 579C836.5 578.448 836.948 578 837.5 578H840.5C841.052 578 841.5 578.448 841.5 579V584C841.5 584.552 841.052 585 840.5 585H837.5C836.948 585 836.5 584.552 836.5 584V579Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M844.5 579C844.5 578.448 844.948 578 845.5 578H848.5C849.052 578 849.5 578.448 849.5 579V584C849.5 584.552 849.052 585 848.5 585H845.5C844.948 585 844.5 584.552 844.5 584V579Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M852.5 579C852.5 578.448 852.948 578 853.5 578H856.5C857.052 578 857.5 578.448 857.5 579V584C857.5 584.552 857.052 585 856.5 585H853.5C852.948 585 852.5 584.552 852.5 584V579Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M860.5 579C860.5 578.448 860.948 578 861.5 578H864.5C865.052 578 865.5 578.448 865.5 579V584C865.5 584.552 865.052 585 864.5 585H861.5C860.948 585 860.5 584.552 860.5 584V579Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 556C828.5 555.448 828.948 555 829.5 555H832.5C833.052 555 833.5 555.448 833.5 556V563C833.5 563.552 833.052 564 832.5 564H829.5C828.948 564 828.5 563.552 828.5 563V556Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M835.5 556C835.5 555.448 835.948 555 836.5 555H839.5C840.052 555 840.5 555.448 840.5 556V563C840.5 563.552 840.052 564 839.5 564H836.5C835.948 564 835.5 563.552 835.5 563V556Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M842.5 556C842.5 555.448 842.948 555 843.5 555H846.5C847.052 555 847.5 555.448 847.5 556V563C847.5 563.552 847.052 564 846.5 564H843.5C842.948 564 842.5 563.552 842.5 563V556Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M849.5 556C849.5 555.448 849.948 555 850.5 555H853.5C854.052 555 854.5 555.448 854.5 556V563C854.5 563.552 854.052 564 853.5 564H850.5C849.948 564 849.5 563.552 849.5 563V556Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M856.5 556C856.5 555.448 856.948 555 857.5 555H860.5C861.052 555 861.5 555.448 861.5 556V563C861.5 563.552 861.052 564 860.5 564H857.5C856.948 564 856.5 563.552 856.5 563V556Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 556C863.5 555.448 863.948 555 864.5 555H867.5C868.052 555 868.5 555.448 868.5 556V563C868.5 563.552 868.052 564 867.5 564H864.5C863.948 564 863.5 563.552 863.5 563V556Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 573V567H827.5V573M839.5 573V567H835.5V573M847.5 573V567H843.5V573M855.5 573V567H851.5V573M863.5 573V567H859.5V573M871.5 576V567H867.5V573",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M818.5 543.5H825.5V565.5H814",
    stroke: "black",
    strokeWidth: 0.6
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5 565.5V570.5C819.5 571.333 820.1 573 822.5 573H825V578H821.5C819 578 814.5 576.3 814.5 571.5V565.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 551H871H873.5H889V543H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 578H900.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5 573H827.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M831.5 573H835.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M839.5 573H843.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M847.5 573H851.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M855.5 573H859.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M863.5 573H867.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M814.5 588H894",
    stroke: "black",
    strokeWidth: 0.6
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M848.5 588V601.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M851.5 588V601.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 540V566C873.5 567.657 874.843 569 876.5 569H901.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 889.5,
    cy: 583.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M897.5 536.5V569",
    stroke: "black",
    strokeWidth: 0.6
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5 543.5H841.5V551",
    stroke: "black",
    strokeWidth: 0.6
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M841.5 543.5H849.75C851.821 543.5 853.5 545.179 853.5 547.25V547.25C853.5 549.321 851.821 551 849.75 551H841.5V543.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 566.5L871 578",
    stroke: "black",
    strokeWidth: 0.6
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M880.5 578L882.5 569V556.5H873.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_24747",
    x1: 21.25,
    y1: 171,
    x2: 21.25,
    y2: 265.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_24747",
    x1: 21.25,
    y1: 401,
    x2: 21.25,
    y2: 495.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_24747",
    x1: 603.227,
    y1: 175,
    x2: 603.227,
    y2: 213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_24747",
    x1: 637.485,
    y1: 180.182,
    x2: 637.485,
    y2: 207.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_24747",
    x1: 568.97,
    y1: 180.182,
    x2: 568.97,
    y2: 207.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_24747",
    x1: 641.227,
    y1: 188.818,
    x2: 641.227,
    y2: 199.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_24747",
    x1: 565.227,
    y1: 188.818,
    x2: 565.227,
    y2: 199.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_24747",
    x1: 603.227,
    y1: 453,
    x2: 603.227,
    y2: 491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_24747",
    x1: 637.485,
    y1: 458.182,
    x2: 637.485,
    y2: 485.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_24747",
    x1: 568.97,
    y1: 458.182,
    x2: 568.97,
    y2: 485.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_24747",
    x1: 641.227,
    y1: 466.818,
    x2: 641.227,
    y2: 477.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_24747",
    x1: 565.227,
    y1: 466.818,
    x2: 565.227,
    y2: 477.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_24747",
    x1: 315.25,
    y1: 215,
    x2: 315.25,
    y2: 295.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_59_24747",
    x1: 602.75,
    y1: 215,
    x2: 602.75,
    y2: 295.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_59_24747",
    x1: 315.25,
    y1: 356,
    x2: 315.25,
    y2: 436.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_59_24747",
    x1: 602.75,
    y1: 356,
    x2: 602.75,
    y2: 436.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_59_24747",
    x1: 468.565,
    y1: 262,
    x2: 468.565,
    y2: 291.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_59_24747",
    x1: 482.567,
    y1: 248,
    x2: 482.567,
    y2: 277.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_59_24747",
    x1: 482.567,
    y1: 180,
    x2: 482.567,
    y2: 209.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_59_24747",
    x1: 468.551,
    y1: 176,
    x2: 468.551,
    y2: 262.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_59_24747",
    x1: 454.567,
    y1: 248,
    x2: 454.567,
    y2: 277.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_59_24747",
    x1: 468.565,
    y1: 404.655,
    x2: 468.565,
    y2: 375.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_59_24747",
    x1: 482.567,
    y1: 418.655,
    x2: 482.567,
    y2: 389.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_59_24747",
    x1: 482.567,
    y1: 486.655,
    x2: 482.567,
    y2: 457.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_59_24747",
    x1: 6.05141,
    y1: 0,
    x2: 6.05141,
    y2: 86.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_59_24747",
    x1: 454.567,
    y1: 418.655,
    x2: 454.567,
    y2: 389.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_59_24747",
    x1: 857.75,
    y1: 375,
    x2: 857.75,
    y2: 455.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_59_24747",
    x1: 857.75,
    y1: 65,
    x2: 857.75,
    y2: 145.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_59_24747",
    x1: 857.75,
    y1: 217,
    x2: 857.75,
    y2: 297.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_59_24747",
    x1: 857.75,
    y1: 369,
    x2: 857.75,
    y2: 449.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_59_24747",
    x1: 857.75,
    y1: 521,
    x2: 857.75,
    y2: 601.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSystem3000);
export default __webpack_public_path__ + "static/media/img_system_3000.ff168ee2a43c7fa6a5659c8733d90c88.svg";
export { ForwardRef as ReactComponent };